module.exports = __webpack_public_path__ + "static/media/IMG_4559.1215a33d.PNG";